module.exports = __webpack_public_path__ + "static/media/Icon-hearts.97e7740a.svg";